export default __webpack_public_path__ + "static/kanha-9658d0d9c6cfbdf7ac945906f5482b74.jpg";